// Typography configuration
export const typography = {
  fonts: {
    display: "'Playfair Display', Georgia, serif",
    sans: "'DM Sans', system-ui, sans-serif",
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
};




